import React, { useEffect, useRef } from 'react';
import(`./styles/${window.__litium.themeName}.scss`);

const MegaMenu = ({
  open,
  onMouseOverMegaMenu,
  onMouseLeaveMegaMenu,
  link,
  blocks,
}) => {
  const blockContainerRef = useRef();

  useEffect(() => {
    if (!blockContainerRef?.current) return;
    blockContainerRef.current.innerHTML = '';
    for (let block of blocks) {
      blockContainerRef.current.appendChild(block);
    }
  }, [blockContainerRef, blocks]);

  return (
    <div
      className={`mega-menu show-for-medium ${open ? 'mega-menu--open' : ''}`}
      onMouseLeave={onMouseLeaveMegaMenu}
      onTouchStart={onMouseOverMegaMenu}
    >
      <div className="row">
        <div className="columns mega-menu__content">
          <div className="mega-menu__links-wrapper">
            {link.links?.length > 0 &&
              link.links.map((subLink, idx) => (
                <div
                  key={link.url + subLink.url + 'mega-sub-' + idx}
                  className="mega-menu__link-group"
                >
                  <a href={subLink.url}>
                    <h6>{subLink.name ?? <>&nbsp;</>}</h6>
                  </a>
                  {subLink.links?.length > 0 &&
                    subLink.links.map((subSubLink) => (
                      <a
                        key={
                          subLink.url +
                          subSubLink.url +
                          subLink.name +
                          'mega-sub-2'
                        }
                        className={`text-medium text-grey-900 ${
                          subLink.boldLinks ? 'mega-menu__link--bold' : ''
                        }`}
                        href={subSubLink.url}
                      >
                        {subSubLink.name}
                      </a>
                    ))}
                </div>
              ))}
          </div>
          {blocks.length > 0 && (
            <div
              className="mega-menu__blocks-wrapper"
              ref={blockContainerRef}
            ></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MegaMenu;
